export const supportedFormats = [
    "wav",
    "aiff",
    "mp3",
    "aac",   // Includes .aac, .m4a
    "flac",
    "alac"   // Apple Lossless
];